module.exports = __webpack_public_path__ + "img/my-type-3.e6c36872.png";